'use client'

import { createContext, useContext, useMemo } from 'react'
import { useSocketStore } from './unified-socket-service'

interface WebSocketContextValue {
  connected: boolean
  send: (eventType: string, data?: any) => void
}

const WebSocketContext = createContext<WebSocketContextValue | null>(null)

export function WebSocketProvider({ children }: { children: React.ReactNode }) {
  const { isConnected, emit } = useSocketStore()

  const value = useMemo(
    () => ({
      connected: isConnected,
      send: emit
    }),
    [isConnected, emit]
  )

  return <WebSocketContext.Provider value={value}>{children}</WebSocketContext.Provider>
}

export function useWebSocket() {
  const context = useContext(WebSocketContext)
  if (!context) {
    // Graceful fallback for anonymous users without socket providers
    return {
      connected: false,
      send: () => {
        console.warn('WebSocket not available - user may not be authenticated')
      }
    }
  }
  return context
}
